const path = 'nurse';
export default {
	// GET
	me: path + '/me',
	cityList: path + '/address-province/all',
	category: path + '/category/health-care/all',
	bookingRequestList: path + '/booking-request/list',
	bookingList: path + '/booking/list',
	booking: path + '/booking', // add booking id
	messageList: path + '/notif/list',
	accountBalance: path + '/account-balance',
	incomeList: path + '/booking/list-income-booking',
	invoices: path + '/invoice',
	monthlyIncome: path + '/income/stats',
	oldRequestList: path + '/booking-request/old/list',
	availableBooking: path + '/booking-request/{requestId}/check-available',
	totalNurse: path + '/nurse/total-nurse',

	// POST
	register: path + '/register',
	registerUpdate: path + '/me/update',
	login: path + '/auth',
	loginLink: path + '/login-link',
	resetPassword: path + '/reset-password',
	forgotPassword: path + '/forgot-password',
	updateProfile: path + '/me/update',
	updateService: path + '/me/update-service',
	updateSchedule: path + '/me/update-schedule',
	acceptBookingRequest: path + '/booking-request/{id}/accept',
	refuseBookingRequest: path + '/booking-request/{id}/refuse',
	refureBookingByNurse: path + '/booking/{id}/refuse',
	cancelBooking: path + '/booking/{id}/cancel',
	markAsReadAll: path + '/notif/mark-as-read-all',
	markAsRead: path + '/notif/{id}/mark-as-read',
	updateBank: path + '/me/update-bank-information',
	bookingIsCompleted: path + '/booking/{id}/update-status-to-completed',
	downloadInvoiceFile: path + '/invoice/{id}/pdf',
	uploadProofKitTest: path + '/booking/{id}/upload-proof-kit-test',
	updateStatus: path + '/booking/{id}/update-status',
	nurseApplyBooking: path + '/booking/{id}/apply',

	// PUT , PATCH

	// DELETE
	deleteMedia: path + '/me/media', // attach id in link
};
